<div class="comparative-analysis-page">
  <div class="top-action-section">
    <div class="filter-container">
      <div class="filter">
        <label class="filter-label">Tickers</label>
        <div class="ticker-search-filter">
          <app-ticker-search
            [tickers]="tickers"
            [onScreen]="true"
            [isComp]="true"
            [hasSearchIcon]="true"
            [disabled]="
              !tickerModalDataReady ||
              isMetaInProgress ||
              isLineItemUpdateInProgress ||
              isUserSettingUpdateInProgress
            "
            [suggestedTickers]="suggestedPeers"
            placeholder="&nbsp;Add Tickers"
            [maxSelectedTickerCount]="tickerLimit"
            (onSearchedTickerUpdate)="onSearchTickerSelection($event)"
          ></app-ticker-search>

          <button
            nz-button
            class="on-screen-search__edit-btn"
            (click)="editTickers()"
            [disabled]="
              !tickerModalDataReady ||
              isMetaInProgress ||
              isLineItemUpdateInProgress ||
              isUserSettingUpdateInProgress
            "
          >
            <!-- [disabled]="
                  !(tickerModalDataReady && metaReady && !tickerDeletionInProcess)
                " -->
            Edit
          </button>
        </div>
      </div>
      <div class="filter lineitem-alignment">
        <app-lineitem-filter
          [options]="ratioLineItemsData"
          [selectedValue]="{}"
          [selectedOptionsId]="selectedRatioId"
          liFilterId="caValuationLI"
          [bottomBorderView]="true"
          [disabled]="
            isMetaInProgress ||
            isUserSettingUpdateInProgress ||
            isLineItemUpdateInProgress
          "
          placeholder="&nbsp;Add Ratios"
          label="Ratios"
          [showButton]="true"
          (onValueChange)="onSearchedLi($event)"
          (onEditButtonClick)="handleEditLineItemsButtonClick()"
        ></app-lineitem-filter>
      </div>
      <div class="filter industry-currency-filter">
        <va-currency-select
          size="small"
          selectWidth="78"
          labelPlacement="top"
          [bottomBorderView]="true"
          [selectedCurrency]="currency"
          [disabled]="isMetaInProgress || isUserSettingUpdateInProgress"
          [apiEP]="apiEP"
          apiUrl="/api/get_available_currencies"
          (onChange)="updateCurrency($event)"
        >
        </va-currency-select>
      </div>
      <div class="filter">
        <va-period-filter
          [filterWidthVariation]="3"
          [periodData]="periodData"
          [disabled]="
            isMetaInProgress || isUserSettingUpdateInProgress || !periodData
          "
          [dataAvailable]="periodsWithAvailableData"
          [periodMinMax]="periodMinMax"
          (onApply)="handlePeriodApply($event)"
        ></va-period-filter>
      </div>
    </div>
    <div class="cta-right-section">
      <div class="valuation-switch-item">
        <nz-radio-group
          [ngModel]="orientationValue"
          nzButtonStyle="solid"
          (ngModelChange)="handleOrientation($event)"
          [nzDisabled]="isMetaInProgress || isUserSettingUpdateInProgress"
          style="font-size: 12px"
        >
          <label nz-radio-button nzValue="grid">
            <va-icon
              size="small"
              isFontAwesome="true"
              [name]="faThLarge"
              class="icon"
              style="vertical-align: -10%"
            ></va-icon
            >Grid</label
          >
          <label nz-radio-button nzValue="list">
            <va-icon size="small" name="menu" class="icon"></va-icon>List</label
          >
        </nz-radio-group>
      </div>
      <app-export-to-excel-dropdown
        [(isPopoverVisible)]="isExportPopoverVisible"
        [disabled]="isMetaInProgress"
        [optionList]="excelToExportDropdownOptions"
        [isExportInProgress]="isExportInProgress"
        (onListItemClick)="handleETEListItemClick($event)"
      ></app-export-to-excel-dropdown>
    </div>
  </div>
  <div *ngIf="isActive" class="comparative-formula-bar second-action-section">
    <app-subheader-formulabar
      [comparativeAnalysisBorderedFormulaBar]="true"
    ></app-subheader-formulabar>
  </div>
  <section class="comparative-valuation-grid-content-section">
    <ng-container *ngIf="orientationValue === 'grid'">
      <div class="grid-content">
        <app-comparative-valuation-grid
          [dataSource$]="valuationGridData$.asObservable()"
          [isVisible]="isActive"
          [showAverage]="true"
          [showMedian]="true"
          [orientation]="orientationValue"
          [periodState]="periodData"
          [highlightGAAP]="highlightGAAP"
          containerClassName="comparative-valuation-grid"
          sortByColumnId="marketCap"
          [isDataInProgress]="isDataInProgress || isMarketDataInProgress"
        ></app-comparative-valuation-grid>
        <div *ngIf="isDataInProgress" class="grid-overlay-loader">
          <img
            class="grid-overlay-loader-img"
            alt="Loading"
            [src]="assets + '/spinner-blue.gif'"
            width="64"
            height="64"
          />
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="orientationValue === 'list'">
      <ng-container *ngFor="let ratio of gridData.ratios">
        <ng-container *ngIf="ratio.charAt(0) !== '#'">
          <div>
            <app-comparative-valuation-grid
              [dataSource$]="valuationGridData$.asObservable()"
              [isVisible]="isActive"
              [showAverage]="true"
              [showMedian]="true"
              [orientation]="orientationValue"
              [ratioId]="ratio"
              [periodState]="periodData"
              [highlightGAAP]="highlightGAAP"
              containerClassName="comparative-valuation-grid"
              [isDataInProgress]="isDataInProgress || isMarketDataInProgress"
            ></app-comparative-valuation-grid>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
    <div
      *ngIf="!isMetaInProgress"
      class="comparative-valuation-footer"
      style="align-self: flex-end"
    >
      <div style="text-align: right">
        {{ magnitudeMessage }}
        <div *ngIf="factSetAccess" style="color: #b0b0b0">
          {{ factsetCopyRightMessage }}
        </div>
      </div>
    </div>
  </section>
</div>

<!-- Snackbar -->
<ng-template #successTemplate>
  <div class="snackbar-content">
    <va-icon name="check" class="snack-icon snack-success-icon"></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon size="small" name="close"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #failureTemplate>
  <div class="snackbar-content">
    <va-icon
      size="small"
      name="close-circle"
      class="snack-icon snack-failure-icon"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon size="small" name="close"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #infoTemplate>
  <div class="snackbar-content">
    <va-icon
      size="small"
      name="info-circle"
      class="snack-icon snack-info-icon"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon size="small" name="close"></va-icon>
    </span>
  </div>
</ng-template>
